function toReadablePersonaName(value) {
  if (!value) return "-";
  return String(value)
    .toLowerCase()
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

function toSortedPersonaList(input) {
  if (!Array.isArray(input)) return [];
  return [...input]
    .map((item, index) => ({
      id: `${item?.name || "persona"}-${index}`,
      name: item?.name || "UNKNOWN",
      displayName: toReadablePersonaName(item?.name),
      matched: Boolean(item?.matched),
      score: Number.isFinite(Number(item?.score)) ? Number(item.score) : 0,
      rank: Number.isFinite(Number(item?.rank)) ? Number(item.rank) : null,
    }))
    .sort((a, b) => {
      if (a.rank == null && b.rank == null) return 0;
      if (a.rank == null) return 1;
      if (b.rank == null) return -1;
      return a.rank - b.rank;
    });
}

function normalizeExplainability(input) {
  if (!Array.isArray(input)) return [];
  return input.map((row, index) => ({
    id: `explainability-${index}`,
    ruleName: row?.ruleName || "-",
    test: row?.test || "-",
    value: row?.value ?? "-",
    matched: Boolean(row?.matched),
    reason: row?.reason || "No reasoning provided",
  }));
}

function normalizeRecommendations(list) {
  if (!Array.isArray(list)) return [];
  return list.map((item, index) => ({
    id: `${item?.title || "recommendation"}-${index}`,
    title: item?.title || "Untitled",
    description: item?.description || "",
    basedOnTests: Array.isArray(item?.basedOnTests) ? item.basedOnTests : [],
  }));
}

export function preparePersonaPayload(apiResponse) {
  const data = apiResponse?.data || {};
  const details = data?.details || {};
  const resolvedDiet = data?.resolvedDiet || {};
  const recommendations = resolvedDiet?.recommendations || {};

  return {
    summary: {
      message: apiResponse?.message || "Persona result",
      clientId: data?.clientId || "-",
      labNo: data?.labNo || "-",
      createdAt: data?.createdAt || null,
      finalPersona: data?.finalPersona || "-",
      primaryPersona: data?.primaryPersona || "-",
      secondaryPersona: data?.secondaryPersona || "-",
      hybridPersona: data?.hybridPersona || "-",
      matchedSecondaryPersonas: Array.isArray(data?.matchedSecondaryPersonas)
        ? data.matchedSecondaryPersonas
        : [],
    },
    personas: {
      primary: toSortedPersonaList(details?.primaryPersonas),
      secondary: toSortedPersonaList(details?.secondaryPersonas),
      hybrid: toSortedPersonaList(details?.hybridPersonas),
      chains: Array.isArray(details?.personaChains) ? details.personaChains : [],
    },
    explainability: normalizeExplainability(data?.explainability),
    diet: {
      name: resolvedDiet?.name || "-",
      focus: resolvedDiet?.focus || "-",
      baseLogic: resolvedDiet?.baseLogic || "-",
      increaseIntake: normalizeRecommendations(recommendations?.increaseIntake),
      limitIntake: normalizeRecommendations(recommendations?.limitIntake),
      modifiers: Array.isArray(resolvedDiet?.modifiers) ? resolvedDiet.modifiers : [],
    },
    raw: apiResponse,
  };
}

export function formatUtcDate(value) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString();
}
